
import { Dashboard, Storefront, Person, Group, Groups, Workspaces, FactCheck, Settings, Category, SupportAgent, VerticalShades, LeakAdd, PostAdd, ViewList, UploadFile, ConnectWithoutContact, AutoStories, MenuBook, School, ThreeP, LocalOffer, BarChart, VerifiedUser, QuestionAnswer, AccountBalanceWallet, EventSeat, Signpost, ContactMail, ViewCarousel, LocalActivity, Euro, Policy } from "@mui/icons-material";
import Colors from "./App/Assets/Styles/Colors";
import { AdstreetIcon } from "./App/Assets/Images/Images";

const styles = {
  iconSize: {
    p: 0.2,
    fontSize: "22px",
    color: Colors.primary,
  },
};

const Navigation = [
  {
    label: "Dashboard",
    icon: <Dashboard sx={styles.iconSize} />,
    path: "/"
  },
  {
    label: "AdBazaar",
    icon: <Storefront sx={styles.iconSize} />,
    subMenu: [
      {
        label: "Individual",
        icon: <Person sx={styles.iconSize} />,
        path: "/individual",
      },
      {
        label: "Service Provider",
        icon: <Group sx={styles.iconSize} />,
        path: "/service-provider",
      },
      {
        label: "Service Seeker",
        icon: <Groups sx={styles.iconSize} />,
        path: "/service-seeker",
      },
      {
        label: "Jobs",
        icon: <Workspaces sx={styles.iconSize} />,
        path: "/jobs",
      },
      {
        label: "Proposals",
        icon: <FactCheck sx={styles.iconSize} />,
        path: "/proposals",
      },
      {
        label: "Settings",
        isOpen: false,
        icon: <Settings sx={styles.iconSize} />,
        subMenu: [
          {
            label: "Categories",
            icon: <Category sx={styles.iconSize} />,
            path: "/categories",
          },
          {
            label: "Services",
            icon: <SupportAgent sx={styles.iconSize} />,
            path: "/services",
          },
          {
            label: "Industries",
            icon: <VerticalShades sx={styles.iconSize} />,
            path: "/industries",
          },
          {
            label: "Upload Banner",
            icon: <UploadFile sx={styles.iconSize} />,
            path: "/upload-adbazaar-banner-image",
          },
          {
            label: "Best Offers",
            icon: <LocalOffer sx={styles.iconSize} />,
            path: "/best-offers",
          },
        ],
      },
    ]
  },
  {
    label: "AdLeaks",
    icon: <LeakAdd sx={styles.iconSize} />,
    subMenu: [
      {
        label: "AdLeak List",
        icon: <ViewList sx={styles.iconSize} />,
        path: "/adleak-list",
      },
      {
        label: "Users AdLeaks",
        icon: <VerifiedUser sx={styles.iconSize} />,
        path: "/users-adleak-list",
      },
      {
        label: "Create AdLeak",
        icon: <PostAdd sx={styles.iconSize} />,
        path: "/adleak-create",
      },
      {
        label: "Upload Banner",
        icon: <UploadFile sx={styles.iconSize} />,
        path: "/upload-banner-image",
      },
      {
        label: "Categories",
        icon: <Category sx={styles.iconSize} />,
        path: "/adleak-category",
      },
      {
        label: "Fresh Leaks",
        icon: <PostAdd sx={styles.iconSize} />,
        path: "/fresh-leaks",
      },
    ]
  },
  {
    label: "AdMeet",
    icon: <ConnectWithoutContact sx={styles.iconSize} />,
    subMenu: [
      {
        label: "AdMeet List",
        icon: <ViewList sx={styles.iconSize} />,
        path: "/admeet-list",
      },
      {
        label: "Users AdMeet",
        icon: <VerifiedUser sx={styles.iconSize} />,
        path: "/users-admeet-list",
      },
      {
        label: "Create AdMeet",
        icon: <PostAdd sx={styles.iconSize} />,
        path: "/admeet-create",
      },
      {
        label: "Upload Banner",
        icon: <UploadFile sx={styles.iconSize} />,
        path: "/upload-admeet-banner-image",
      },
      {
        label: "Categories",
        icon: <Category sx={styles.iconSize} />,
        path: "/admeet-category",
      },
    ]
  },
  {
    label: "AdBook",
    icon: <AutoStories sx={styles.iconSize} />,
    subMenu: [
      {
        label: "AdBook List",
        icon: <ViewList sx={styles.iconSize} />,
        path: "/adbooks-list",
      },
      {
        label: "Users AdBook",
        icon: <VerifiedUser sx={styles.iconSize} />,
        path: "/users-adbook-list",
      },
      {
        label: "Create AdBook",
        icon: <PostAdd sx={styles.iconSize} />,
        path: "/adbook-create",
      },
      {
        label: "Upload Banner",
        icon: <UploadFile sx={styles.iconSize} />,
        path: "/upload-adbooks-banner-image",
      },
      {
        label: "Categories",
        icon: <Category sx={styles.iconSize} />,
        path: "/adbook-category",
      },
    ]
  },
  {
    label: "AdRead",
    icon: <MenuBook sx={styles.iconSize} />,
    subMenu: [
      {
        label: "AdRead List",
        icon: <ViewList sx={styles.iconSize} />,
        path: "/adread-list",
      },
      {
        label: "Create AdRead",
        icon: <PostAdd sx={styles.iconSize} />,
        path: "/adread-create",
      },
      {
        label: "Upload Banner",
        icon: <UploadFile sx={styles.iconSize} />,
        path: "/upload-adread-banner-image",
      },
      {
        label: "Categories",
        icon: <Category sx={styles.iconSize} />,
        path: "/adread-category",
      },
    ]
  },
  {
    label: "AdGuru",
    icon: <School sx={styles.iconSize} />,
    subMenu: [
      {
        label: "AdGuru List",
        icon: <ViewList sx={styles.iconSize} />,
        path: "/adguru-list",
      },
      {
        label: "Create AdGuru",
        icon: <PostAdd sx={styles.iconSize} />,
        path: "/adguru-create",
      },
      {
        label: "Upload Banner",
        icon: <UploadFile sx={styles.iconSize} />,
        path: "/upload-adguru-banner-image",
      },
      {
        label: "Categories",
        icon: <Category sx={styles.iconSize} />,
        path: "/adguru-category",
      },
    ]
  },
  {
    label: "AdPro",
    icon: <ThreeP sx={styles.iconSize} />,
    subMenu: [
      {
        label: "AdPro List",
        icon: <ViewList sx={styles.iconSize} />,
        path: "/adpro-list",
      },
      // {
      //   label: "Upload Banner",
      //   icon: <UploadFile sx={styles.iconSize} />,
      //   path: "/upload-adpro-banner-image",
      // },
      {
        label: "Services",
        icon: <Category sx={styles.iconSize} />,
        path: "/adpro-services",
      },
    ]
  },
  {
    label: "AdStreet",
    icon: <Signpost sx={styles.iconSize} />,
    subMenu: [
      {
        label: "Create Event / Banner",
        icon: <LocalActivity sx={styles.iconSize} />,
        path: "/upload-home-banner-image",
      },
      {
        label: "Events",
        icon: <EventSeat sx={styles.iconSize} />,
        path: "/events",
      },
      {
        label: "Settings",
        icon: <Settings sx={styles.iconSize} />,
        subMenu: [
          {
            label: "Banners",
            icon: <ViewCarousel sx={styles.iconSize} />,
            path: "/banners",
          },
          {
            label: "Email Users",
            icon: <ContactMail sx={styles.iconSize} />,
            path: "/email-users",
          },
        ]
      },
    ]
  },
  {
    label: "Escrow Accounts",
    icon: <AccountBalanceWallet sx={styles.iconSize} />,
    path: "/escrow-accounts",
  },
  {
    label: "Withdraw Request",
    icon: <Euro sx={styles.iconSize} />,
    path: "/withdraw-request",
  },
  {
    label: "Jobs On Hold",
    icon: <Policy sx={styles.iconSize} />,
    path: "/on-hold",
  },
];

export default Navigation;